import Const from 'constants';
import {calculatePlayersRange} from 'helpers/common-helper';

let SalaryBoundary = {
    setInnerSalaryBoundaryFromStorage(items) {
        return (dispatch) => {
            dispatch(this.setInnerSalaryBoundary(items, {countPlayers: false, saveToStorage: false}));
        };
    },

    setInnerSalaryBoundary(items, options = {}) {
        return (dispatch) => {
            const {countPlayers = true, saveToStorage = true} = options;

            dispatch({
                type: Const.SALARY_BOUNDARY_SET_INNER,
                items,
            });

            countPlayers && dispatch(this.setPlayersCounters());

            saveToStorage && dispatch(
                this.saveDataToStorage('salaryBoundary', function (state) {
                    const {salaryBoundary} = state;
                    return {
                        innerBoundaries: salaryBoundary.getInnerBoundaries(),
                    };
                }),
            );
        };
    },

    setOuterSalaryBoundary(items) {
        return {
            type: Const.SALARY_BOUNDARY_SET_OUTER,
            items,
        };
    },

    setSalaryBoundary(mode = null) {
        return (dispatch, getState) => {
            const {
                modesConfig,
                sportConfig,
                playersData: {players},
            } = getState();

            const modes = mode === null ? modesConfig.all({asArr: true}) : [modesConfig.getConfig(mode)];

            const items = {};
            modes.map((mode) => {
                if (!mode.isUsedInSalaryFilter()) {
                    return;
                }

                const range = calculatePlayersRange(players.all(), mode.getPropPrefix() + 'salary', {
                    parseValue: (value) => parseInt(value),
                    shouldPlayerBeSkipped:
                        mode.getRole() === 'FLEX'
                            ? () => false
                            : (player) => sportConfig.isSportF1() && player.isConstructor(),
                });

                if (range.min >= range.max) {
                    range.max = parseInt(range.min + 1000);
                }

                items[mode.getRole()] = range;
            });
            // console.log('items',{...items});
            dispatch(this.setOuterSalaryBoundary(items));
        };
    },
};

export default SalaryBoundary;
